import Storage from "react-native-storage";

const storage = new Storage({
  storageBackend: window.localStorage,
  defaultExpires: null,
});

export default storage;



// WEBPACK FOOTER //
// ./src/utils/storage.web.js